import SkillsContainer from "../../containers/MySkillsItem/MySkillsItem"
import "./PersonalCardItem.css"
import BackgroungDogs from "../../utils/img/dogos.JPG"

function PersonalCardItem() {
	return (
		<div className="card card-about">
			<section className="card card-personal">
				<aside className="card-text">
					<section className="card-title">
						<h1 className="big-tittle">About me:</h1>
					</section>
					<p>
						<span>Hello again!👋</span>
					</p>
				</aside>
				<aside className="card-window" />
				<aside className="card-text">
					<p>
						I am an IT professional passionate about technology, software development, and
						continuous learning. Currently in the final semesters of my Systems and Computer
						Engineering degree, I combine hands-on experience in software development and technical
						support with a strong foundation in modern programming languages and frameworks.
					</p>
					<div>
						<h3>
							<b>My Skills</b>
						</h3>
						<SkillsContainer />
					</div>
					<p>
						I have delivered comprehensive software solutions for customer service and
						administrative systems, leveraging technologies such as Java, JavaScript, and PL/SQL.
					</p>
				</aside>
				<aside className="card-window" />
				<aside className="card-text">
					<p>
						Thank you for visiting my web portfolio. Here, you can learn more about my professional
						evolution, notable projects, and how my passion for technology has translated into
						tangible results. I hope you enjoy exploring my journey and skills!
					</p>
					<h3 className="search-job">
						{" "}
						<b>My Professional Vision</b>
					</h3>
					<p>
						Passionate about continuous growth in software engineering and IT service management, I
						aim to apply my technical skills and adaptability to create innovative solutions that
						drive efficiency and value across global industries.
					</p>
					{/*<p>Si quieres ponerte en contacto conmigo, por favor completa este pequeño <a href='#'>formulario</a></p>*/}
				</aside>
			</section>
			<section className="card parallax">
				<figure>
					<img src={BackgroungDogs} alt="Perros" />
				</figure>
			</section>
		</div>
	)
}

export { PersonalCardItem }
